var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuidesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 44.995 44.995",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.497,
    cy: 22.497,
    r: 22.497,
    fill: "#011b33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00e1ff",
    d: "M11.664 22.295l3.66-.825 5.219.219 7.563-6.844 2.699-.727-1.231 3.633-9.593 8.719-2.563-2-5.084-1.813-.67-.362z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.805 14.118l-10.533 10.58a.58.58 0 0 0-.221-.127l-8.175-2.173a.583.583 0 0 1-.197-.104h-.015l6.215 3.363a3.562 3.562 0 0 1 1.428 1.42l3.337 6.083v.003a.578.578 0 0 0 .128.23l.014.025.001-.012a.583.583 0 0 0 .579.175.59.59 0 0 0 .392-.344l7.368-17.78a1.162 1.162 0 0 0-.32-1.34z",
    fill: "#00e1ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 24.571a.58.58 0 0 1 .222.128l10.533-10.581a1.156 1.156 0 0 0-1.227-.208L11.8 21.285a.59.59 0 0 0-.318.77.678.678 0 0 0 .393.343z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidesIcon);
export default __webpack_public_path__ + "static/media/Guides-icon.82623b50464e79e90c151c68e07f5503.svg";
export { ForwardRef as ReactComponent };